import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('shared_business_rule', '/business_rules')
const reducer = generator.generate()

export default reducer
